import styled from "styled-components";

const NotificationStyle = styled.div`
  .notification-page-title {
    font-size: 20px;
    font-weight: 500;
    color: #1f243b;
    margin: 0 0 20px;
  }

  .notification-filters {
    display: flex;
    gap: 12px;
    margin-bottom: 16px;
  }

  .notification-search {
    max-width: 280px;
    border-radius: 24px;
  }

  .notification-date-filter {
    width: 160px;
    border-radius: 24px;
  }

  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    border: 1px solid #00000024;
    border-radius: 8px;
  }

  .ant-table-cell {
    padding: 20px;
    color: #636980;
    font-family: "DM Sans", sans-serif;
  }

  .ant-table-thead {
    font-family: "DM Sans", sans-serif;
    font-weight: 500;
    color: #1f243b;
    white-space: nowrap;
  }

  .ant-table-thead > tr > th::before {
    display: none !important;
  }

  .ant-table-cell-row-hover {
    background: transparent !important;
  }

  .notification-row.unread td {
    background: #f3fefa !important;
  }

  .notification-row {
    cursor: pointer;
  }

  .notification-subject-cell {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .notification-unread-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #ff3f7c;
    flex-shrink: 0;
  }

  .notification-subject-text {
    color: #636980;
  }

  .notification-subject-text b {
    color: #1f243b;
    font-weight: 600;
  }
`;

export default NotificationStyle;
